// eslint-disable-next-line no-unused-vars
import Input from 'reactstrap/lib/Input'; // eslint-disable-next-line no-unused-vars

export default Input;